var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button-bar", {
    staticClass: "flex-row align-items-center",
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-end flex-row align-items-center",
              },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.merge-client-profile-modal",
                        modifiers: { "merge-client-profile-modal": true },
                      },
                    ],
                    staticClass: "mr-2 d-none d-md-block",
                    attrs: { size: "sm", variant: "white", type: "button" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("client-profile.actions.mergeClientProfile")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "white",
                      "class-name": "btn-sm p-0",
                      loading: _vm.loadingState.loading,
                      "loading-succeeded": _vm.loadingState.loadingSucceeded,
                    },
                  },
                  [
                    _c(
                      "b-dropdown",
                      {
                        ref: "actionsDropdown",
                        attrs: {
                          variant: "white",
                          "toggle-class": "btn-sm shadow-none b-0",
                          "menu-class": "overflow-visible",
                          right: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "button-content",
                            fn: function () {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "d-lg-inline d-none" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("global.words.actions")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "i",
                                  { staticClass: "material-icons d-lg-none" },
                                  [_vm._v("more_vert")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _vm._v(" "),
                        _vm.clientProfileDetails.active
                          ? [
                              _c(
                                "b-dropdown-item-button",
                                [
                                  _c("move-board-dropdown", {
                                    attrs: {
                                      profile: _vm.clientProfileDetails,
                                      "client-profile-id": _vm.clientProfileId,
                                    },
                                    on: { select: _vm.handleBoardSelect },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value:
                                        "duplicate-client-profile-modal-" +
                                        _vm.clientProfileId,
                                      expression:
                                        "`duplicate-client-profile-modal-${clientProfileId}`",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "client-profile.actions.createNewProfile"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-dropdown-divider"),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.left",
                                      value: {
                                        title: _vm.masterSubscribeDisabledTitle,
                                        disabled: !_vm.disabledMasterSubscribe,
                                      },
                                      expression:
                                        "{\n                title: masterSubscribeDisabledTitle,\n                disabled: !disabledMasterSubscribe\n              }",
                                      modifiers: { left: true },
                                    },
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.master-unsubscribe-confirmation-modal",
                                      modifiers: {
                                        "master-unsubscribe-confirmation-modal": true,
                                      },
                                    },
                                  ],
                                  attrs: {
                                    disabled: _vm.disabledMasterSubscribe,
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "master-unsubscribe text-danger",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.subscribeText) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-dropdown-divider"),
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.active-status-modal",
                                      modifiers: {
                                        "active-status-modal": true,
                                      },
                                    },
                                  ],
                                },
                                [
                                  _c("a", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "client-profile.actions.markAsInactive"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "b-dropdown-item-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.active-status-modal",
                                      modifiers: {
                                        "active-status-modal": true,
                                      },
                                    },
                                  ],
                                },
                                [
                                  _c("a", { staticClass: "mark-active" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "client-profile.actions.reactivate"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-dropdown-divider"),
                            ],
                        _vm._v(" "),
                        _c("b-dropdown-item-button", [
                          _c(
                            "a",
                            {
                              staticClass: "delete-client-profile text-danger",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#delete-client-profile-modal",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "client-profile.actions.deleteClientProfile"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "dropdown-content",
        fn: function () {
          return [
            _vm.clientProfileDetails.active
              ? [
                  _c(
                    "b-dropdown-item-button",
                    [
                      _c("move-board-dropdown", {
                        attrs: {
                          profile: _vm.clientProfileDetails,
                          "client-profile-id": _vm.clientProfileId,
                        },
                        on: { select: _vm.handleBoardSelect },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.merge-client-profile-modal",
                          modifiers: { "merge-client-profile-modal": true },
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("client-profile.actions.mergeClientProfile")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal",
                          value:
                            "duplicate-client-profile-modal-" +
                            _vm.clientProfileId,
                          expression:
                            "`duplicate-client-profile-modal-${clientProfileId}`",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("client-profile.actions.createNewProfile")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.left",
                          value: {
                            title: _vm.masterSubscribeDisabledTitle,
                            disabled: !_vm.disabledMasterSubscribe,
                          },
                          expression:
                            "{\n          title: masterSubscribeDisabledTitle,\n          disabled: !disabledMasterSubscribe\n        }",
                          modifiers: { left: true },
                        },
                        {
                          name: "b-modal",
                          rawName:
                            "v-b-modal.master-unsubscribe-confirmation-modal",
                          modifiers: {
                            "master-unsubscribe-confirmation-modal": true,
                          },
                        },
                      ],
                      attrs: { disabled: _vm.disabledMasterSubscribe },
                    },
                    [
                      _c(
                        "a",
                        { staticClass: "master-unsubscribe text-danger" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.subscribeText) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.active-status-modal",
                          modifiers: { "active-status-modal": true },
                        },
                      ],
                    },
                    [
                      _c("a", { staticClass: "text-danger" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("client-profile.actions.markAsInactive")
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              : [
                  _c(
                    "b-dropdown-item-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.active-status-modal",
                          modifiers: { "active-status-modal": true },
                        },
                      ],
                    },
                    [
                      _c("a", { staticClass: "mark-active" }, [
                        _vm._v(
                          _vm._s(_vm.$t("client-profile.actions.reactivate"))
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                ],
            _vm._v(" "),
            _c("b-dropdown-item-button", [
              _c(
                "a",
                {
                  staticClass: "delete-client-profile text-danger",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#delete-client-profile-modal",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("client-profile.actions.deleteClientProfile"))
                  ),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }